import { Nullable } from '../constants/types';
import { VariableType } from '../enum/variable-type.enum';

export abstract class VariableValue {
  public valueId: Nullable<number> = null;
  public variableId: Nullable<number> = null;
  public variableName: string = '';
  public variableType: Nullable<VariableType> = null;
  public value: number = 0;
  public valueMax: Nullable<string> = null;
  public effectiveDate: Nullable<Date> = null;
  public validFrom: Nullable<Date> = null;
  public validTo: Nullable<Date> = null;
  public isCurrentApplicable: Nullable<boolean> = null;
  public isFutureApplicable: Nullable<boolean> = null;
  public modificationDate: Nullable<Date> = null;

  public get unit(): string {
    return this.variableType == VariableType.MONEY ? 'CHF' : 'minutes';
  }
}
